import React from 'react';
import PropTypes from 'prop-types';

import { Menu as MUIMenu } from '@mui/material';

// getContentAnchorEl existed in v4 to control anchor positioning but was removed in v5
// (anchorOrigin/transformOrigin alone now handle it) — accepted here for backward
// compatibility with existing call sites, but not forwarded to the underlying v5 Menu.
export const Menu = ({ getContentAnchorEl, ...props }) => <MUIMenu {...props} />; // eslint-disable-line no-unused-vars

Menu.propTypes = {
  anchorEl: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  anchorOrigin: PropTypes.object,
  children: PropTypes.node,
  getContentAnchorEl: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  keepMounted: PropTypes.bool,
  onClick: PropTypes.func,
  onClose: PropTypes.func,
  open: PropTypes.bool.isRequired,
  transformOrigin: PropTypes.object
};

export default Menu;
